<template>
    <v-form @submit.prevent="onSubmit">
        <v-card elevation="0">
            <v-card-text>
                <v-row>
                    <!-- file -->
                    <v-col cols="12">
                        <v-file-input
                            v-model="$v.form.file.$model"
                            :label="$t('bulk_orders_import.file')"
                            :error-messages="fileErrors"
                            @input="$v.form.file.$touch()"
                            @blur="$v.form.file.$touch()"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn type="submit" color="primary" :loading="isBusy" block dark>
                    {{ $t('bulk_orders_import.upload') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
import {API} from "@/api/api";
import SnackbarMixin from "@/mixins/SnackbarMixin.vue";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

export default {
    name: "CreateBulkOrderImportForm",
    mixins: [SnackbarMixin, validationMixin],
    props: {
        warehouseId: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        // loading
        isBusySubmit: false,
        // form data
        form: {
            file: null
        }
    }),
    validations: {
        form: {
            file: {required}
        }
    },
    computed: {
        isBusy() {
            return this.isBusySubmit;
        },
        fileErrors() {
            const errors = [];
            if (!this.$v.form.file.$dirty) return errors;
            !this.$v.form.file.required && errors.push(this.$t('validation.file.required'));
            return errors;
        }
    },
    methods: {
        onSubmit() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }

            const formData = new FormData();
            formData.append("file", this.form.file);

            this.isBusySubmit = true;
            API.post("/api/bulk-order-imports?warehouseId=" + this.warehouseId, formData)
                .then(response => {
                    this.$emit("onSubmit", response.data.id);
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusySubmit = false;
                });
        }
    }
}
</script>
